/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
function e(e){return r=>{if(e.immediate)return e.immediate.schedule(r);const o="No immediate scheduler";throw console.error(o),new Error(o)}}export{e as makeScheduleFunction};
